/* global fastspringStorefront fastspringLibraryUrl */
/* eslint no-unused-vars: 0 indent: 0 */

var s = document.createElement("script");
s.type = "text/javascript";
s.src = fastspringLibraryUrl;
s.id = "fsc-api";
s.setAttribute("data-storefront", fastspringStorefront);
s.setAttribute("data-data-callback", "updateSubscriptionPricing");
s.setAttribute("data-decorate-callback", "decorateURL");
//s.setAttribute("data-debug", "true");
$("head").append(s);

function updateSubscriptionPricing(data) {
    $(function() {
        var items = data.groups[0].items;
        $.each(items,
            function(key, valueObj) {
                var itemUnitPrice;
                var itemPath = valueObj.path;

                var priceSource = $("[data-" + itemPath + "]").data("item-price-src");

                if (priceSource === "dynamic") {
                    itemUnitPrice = valueObj.future.unitPrice;
                } else {
                    itemUnitPrice = $("[data-" + itemPath + "]")
                        .find("[data-item-price]")
                        .text();
                }
                var pricePieces = itemUnitPrice.split(".");

                var priceString = "<span data-item-dollars>" + pricePieces[0] + "</span>";
                if (pricePieces[1] != undefined) {
                    priceString += ".";
                    priceString += "<span data-item-cents>" + pricePieces[1] + "</span>";
                }
                $("[data-" + itemPath + "]")
                    .find("[data-item-price]")
                    .html(priceString);
            });
    });
}

function decorateURL(url) {
    if (window.clsid) {
        var pl = '&clientId=' + window.clsid.client_id + '&sessionId=' + window.clsid.session_id;
    }
    return url + '?' + pl;
}
